import { createSlice } from '@reduxjs/toolkit';
import { ApiRuleType, RuleType } from 'src/features/Automation/types';

export type RulesStateType = {
  items: Array<ApiRuleType>;
  status: string;
  meta: {
    page: number;
    total: number;
    next: null | string;
  };
};

const initialState: RulesStateType = {
  items: [],
  status: 'idle',
  meta: {
    page: 1,
    total: 0,
    next: null,
  },
};

const rulesSlice = createSlice({
  name: 'rules',
  initialState,
  reducers: {
    deleteRule: (state, action) => {
      state.items = state.items.filter(
        ({ id }: RuleType) => id !== action.payload.id
      );
      state.meta.total -= 1;
    },
    addRule: (state, action) => {
      state.items = [action.payload.item, ...state.items];
      state.meta.total = +1;
    },
    updateRule: (state, action) => {
      state.items.splice(
        state.items.findIndex(item => item.id === action.payload.item.id),
        1,
        action.payload.item
      );
    },
    fetchRules: (state, action) => {
      if (!action.payload.items) return;

      state.items = action.payload.items;
      state.meta.total = action.payload.total;
    },
  },
});

export default rulesSlice.reducer;

export const {
  fetchRules: fetchRulesAction,
  addRule: addRuleAction,
  updateRule: updateRuleAction,
  deleteRule: deleteRuleAction,
} = rulesSlice.actions;
